export const EMPTY_TRANSLATION = '<empty/>';
//# sourceMappingURL=constants.js.map